import { Button, UIHeading2, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import clsx from 'classnames';

import { ICPDBannerData } from './types';
import styles from './CPDBanner.css';

interface ICPDBannerProps {
  submitRequest: VoidFunction;
  isDesktop: boolean;
  CPDBannerData: ICPDBannerData;
}

export const CPDBanner: React.FC<ICPDBannerProps> = props => {
  const { submitRequest, isDesktop, CPDBannerData } = props;

  const HeadingTypography = isDesktop ? UIHeading2 : UIHeading4;
  const TextTypography = isDesktop ? UIText1 : UIText2;

  const { header, description, buttonText } = CPDBannerData[isDesktop ? 'desktop' : 'mobile'];

  return (
    <section className={clsx(styles['container'], !isDesktop && styles['mobile'])} data-testid="CPDBanner">
      <div className={clsx(styles['content_container'], !isDesktop && styles['mobile'])}>
        {header && <HeadingTypography>{header}</HeadingTypography>}
        {description && (
          <div className={styles['text_wrapper']}>
            <TextTypography>{description}</TextTypography>
          </div>
        )}
        {buttonText && (
          <Button onClick={submitRequest} data-testid="CPDBannerSubmitButton">
            {buttonText}
          </Button>
        )}
      </div>
    </section>
  );
};
